import './style.scss';
import Swiper from 'swiper/bundle';

// import styles bundle
import 'swiper/css/bundle';

// init Swiper:
// eslint-disable-next-line no-unused-vars
const mvSlider = new Swiper('.mv-slider', {
  effect: "fade",
  fadeEffect: {
    crossFade: true
  },
  loop: true,
  speed: 3000,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});

